/**
 * What the Skills page's buttons copy (ADR-216 §2.4). The package name must be
 * the one published to the public npm registry — mcpSetupCommand.test.ts
 * compares it with packages/mcp-server/package.json, so a rename cannot ship a
 * command that 404s for every customer (#789).
 */
export const MCP_PACKAGE = '@systemdox/mcp-server';

/**
 * Paste into a terminal: installs with no agent, into ~/.claude/skills/<name>/.
 * With `version`, that version rather than the latest (ADR-216 Amendment 1).
 */
export function installSkillCommand(name: string, version?: number): string {
  return `npx -y ${MCP_PACKAGE} install-skill ${name}${version ? ` --version ${version}` : ''}`;
}

/** Paste into a Claude session that has the SystemDox MCP server connected. */
export function copyForClaudeText(name: string): string {
  return `Install the ${name} skill from SystemDox.`;
}

/**
 * Team setup's "Set up this computer" (ADR-217 §2.4): the one command that
 * installs the team's plugin, instructions and memory on a computer.
 */
export function setupCommand(): string {
  return `npx -y ${MCP_PACKAGE} setup`;
}
